<script setup lang="ts">
import type { StepsComponentModel } from '@su4r-frontend/api';
defineProps<StepsComponentModel>();

const localeRoute = useLocaleRoute();
</script>

<template>
    <section class="tile-top-right bg-blue-light flex flex-col gap-4 lg:gap-6">
        <header class="flex flex-col gap-4">
            <h2 v-if="title" class="order-2 text-3xl lg:text-4xl">{{ title }}</h2>
            <!-- <h3 v-if="subtitle" class="font-body order-1">{{ subtitle }}</h3> -->
        </header>

        <div class="lg:grid-cols-auto-fit grid grid-cols-1 gap-y-4 lg:gap-x-6">
            <section
                v-for="(item, index) in steps"
                :key="`item-${index}`"
                class="flex flex-col gap-2">
                <header class="flex flex-row gap-2">
                    <div
                        v-if="showStepCounter"
                        class="grid h-6 w-6 place-items-center rounded-full bg-white text-sm font-bold">
                        {{ index + 1 }}
                    </div>
                    <h4 class="font-body font-semibold">{{ item.title }}</h4>
                </header>
                <div v-html="item.body"></div>
                <NuxtLink
                    v-if="item.link"
                    :to="localeRoute(item.link.url)"
                    :target="item.link.openInNewTab ? '_blank' : '_self'"
                    class="btn-secondary-a"
                    >{{ item.link.title }}</NuxtLink
                >
            </section>
        </div>
    </section>
</template>
